"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/ChatBubble` instead */
export const ChatBubble = createSVGIcon(
  <path
    d="M11.997.923A11.07 11.07 0 0 0 2.239 6.77a11.08 11.08 0 0 0 .541 11.365L.923 23.077l6.218-1.125a11.072 11.072 0 0 0 15.652-7.46A11.08 11.08 0 0 0 16.81 2.022 11.1 11.1 0 0 0 11.997.923Z"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "ChatBubble",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
